export default __webpack_public_path__ + "static/media/bg2.7a5feb14.png";